import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "master_svg0_20898_65021/18645_27088" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0",
      y: "0",
      width: "64",
      height: "64",
      rx: "0"
    })
  ]),
  /*#__PURE__*/_createElementVNode("clipPath", { id: "master_svg1_20898_65021/18645_27088/18645_12251" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0",
      y: "0",
      width: "64",
      height: "64",
      rx: "0"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#master_svg0_20898_65021/18645_27088)" }, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#master_svg1_20898_65021/18645_27088/18645_12251)" }, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M32.00019609375,58.66679609375C46.72779609375,58.66679609375,58.66679609375,46.72779609375,58.66679609375,32.00019609375C58.66679609375,17.27259609375,46.72779609375,5.33349609375,32.00019609375,5.33349609375C17.27259609375,5.33349609375,5.33349609375,17.27259609375,5.33349609375,32.00019609375C5.33349609375,46.72779609375,17.27259609375,58.66679609375,32.00019609375,58.66679609375ZM28.90649609375,34.68579609375L41.90829609375,23.57549609375C42.24479609375,23.28829609375,42.74489609375,23.30789609375,43.05769609375,23.62139609375L44.30179609375,24.86849609375C44.63329609375,25.20069609375,44.63329609375,25.73839609375,44.30179609375,26.06979609375L29.24469609375,41.16269609375C28.91319609375,41.49479609375,28.37589609375,41.49479609375,28.04529609375,41.16269609375L21.26889609375,34.37149609375C20.93839609375,34.039296093749996,20.93839609375,33.501596093749995,21.26889609375,33.17019609375L22.56489609375,31.87209609375C22.85559609375,31.57979609375,23.31329609375,31.53989609375,23.64979609375,31.77609609375L27.87079609375,34.73509609375C28.18779609375,34.95679609375,28.61229609375,34.93629609375,28.90649609375,34.68579609375Z",
        "fill-rule": "evenodd",
        fill: "#00C677",
        "fill-opacity": "1"
      })
    ])
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { withDefaults } from 'vue'
import IconSvgWrap from './IconSvgWrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IconCircleSuccess',
  props: {
    fillColor: { default: '' },
    size: { default: 16 }
  },
  setup(__props: any) {

const props = __props as { fillColor: string, size: number };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IconSvgWrap, {
    size: props.size
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        fill: "none",
        version: "1.1",
        width: props.size,
        height: props.size,
        viewBox: "0 0 64 64"
      }, _hoisted_4, 8, _hoisted_1))
    ]),
    _: 1
  }, 8, ["size"]))
}
}

})